export default "__VITE_ASSET__YHNTWCG___"